import { ReportHandler } from 'web-vitals';
import { sendTelemetry } from './utils/telemetry';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    const handler: ReportHandler = (metric) => {
      if (onPerfEntry && onPerfEntry instanceof Function) {
        onPerfEntry(metric);
      }

      void sendTelemetry({
        level: 'info',
        eventType: 'web_vital',
        metricName: metric.name,
        metricValue: metric.value,
        metadata: {
          delta: metric.delta,
          id: metric.id,
        },
      });
    };

    getCLS(handler);
    getFID(handler);
    getFCP(handler);
    getLCP(handler);
    getTTFB(handler);
  });
};

export default reportWebVitals;
